export const TeamTypeSchema = ["OPERATOR", "DEVELOPER", "SUPER"] as const;

export type TeamType = (typeof TeamTypeSchema)[number];
